import { render } from "./radar-chart-sudent.vue?vue&type=template&id=42b7da12"
import script from "./radar-chart-sudent.vue?vue&type=script&lang=js"
export * from "./radar-chart-sudent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__